import React from 'react';
import { Pagination } from 'react-bootstrap';

interface PaginatedProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Paginated: React.FC<PaginatedProps> = ({ currentPage, totalPages, onPageChange }) => {
  const paginationItems = [];

  if (totalPages <= 5) {
    // Si hay menos de 5 páginas, muestra todas
    for (let i = 1; i <= totalPages; i++) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => onPageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }
  } else {
    // Mostrar siempre la primera página
    paginationItems.push(
      <Pagination.Item
        key={1}
        active={1 === currentPage}
        onClick={() => onPageChange(1)}
      >
        1
      </Pagination.Item>
    );

    if (currentPage > 3) {
      // Puntos suspensivos si estamos después de la segunda página
      paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    // Páginas alrededor de la actual
    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);
    for (let i = startPage; i <= endPage; i++) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => onPageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages - 2) {
      // Puntos suspensivos si estamos antes de la penúltima página
      paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    // Mostrar siempre la última página
    paginationItems.push(
      <Pagination.Item
        key={totalPages}
        active={totalPages === currentPage}
        onClick={() => onPageChange(totalPages)}
      >
        {totalPages}
      </Pagination.Item>
    );
  }

  return (
    <Pagination className="justify-content-center">
      <Pagination.First onClick={() => onPageChange(1)} disabled={currentPage === 1} />
      <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} />
      {paginationItems}
      <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} />
      <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages} />
    </Pagination>
  );
};

export default Paginated;
